export default "__VITE_ASSET__B8Wiao66__"